// extracted by mini-css-extract-plugin
export var deleteModal = "_gx-0";